import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControl } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from '@/store';
import { adActions } from '@/store/ad';
import { AdComponentProps } from '@/pages/Ad/types';
import { DocumentSelector } from '../DocumentSelector';

export const VerificationDocumentSelector: FC<AdComponentProps> = (props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { verificationDocuments, noVerificationDocumentsConfirmed } = useAppSelector((state) => state.ad);

  return (
    <>
      <DocumentSelector {...props} variant="verification" />
      {verificationDocuments.length === 0 && (
        <FormControl mt={4} mb={4}>
          <Checkbox
            isChecked={noVerificationDocumentsConfirmed}
            onChange={(e) => dispatch(adActions.setNoVerificationDocumentsConfirmed(e.target.checked))}
          >
            {t('ad.steps.verificationDocuments.confirmNoDocuments')}
          </Checkbox>
        </FormControl>
      )}
    </>
  );
};
